import { IgrColumn } from './igr-column';
import { GridCellValueChangingEventArgs as GridCellValueChangingEventArgs_internal } from "./GridCellValueChangingEventArgs";
import { IgrDateTimeCellInfo } from "./igr-date-time-cell-info";
import { IgrImageCellInfo } from "./igr-image-cell-info";
import { IgrNumericCellInfo } from "./igr-numeric-cell-info";
import { IgrRowSeparatorInfo } from "./igr-row-separator-info";
import { IgrSectionHeaderCellInfo } from "./igr-section-header-cell-info";
import { IgrTemplateCellInfo } from "./igr-template-cell-info";
import { IgrTemplateHeaderCellInfo } from "./igr-template-header-cell-info";
import { IgrTemplateSectionHeaderCellInfo } from "./igr-template-section-header-cell-info";
import { IgrTextCellInfo } from "./igr-text-cell-info";
import { IgrTextHeaderCellInfo } from "./igr-text-header-cell-info";
/**
 * Event arguments for the CellValueChanging event
*/
var IgrGridCellValueChangingEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridCellValueChangingEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridCellValueChangingEventArgs.prototype.createImplementation = function () {
        return new GridCellValueChangingEventArgs_internal();
    };
    Object.defineProperty(IgrGridCellValueChangingEventArgs.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridCellValueChangingEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridCellValueChangingEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridCellValueChangingEventArgs.prototype, "cellInfo", {
        /**
         * The backing information for the current cell.
        */
        get: function () {
            if (this.i.cellInfo == null) {
                return null;
            }
            if (!this.i.cellInfo.externalObject) {
                var ext = null;
                switch (this.i.cellInfo.$type.name) {
                    case "DateTimeCellModel":
                        ext = new IgrDateTimeCellInfo();
                        break;
                    case "ImageCellModel":
                        ext = new IgrImageCellInfo();
                        break;
                    case "NumericCellModel":
                        ext = new IgrNumericCellInfo();
                        break;
                    case "RowSeparatorModel":
                        ext = new IgrRowSeparatorInfo();
                        break;
                    case "SectionHeaderCellModel":
                        ext = new IgrSectionHeaderCellInfo();
                        break;
                    case "TemplateCellModel":
                        ext = new IgrTemplateCellInfo();
                        break;
                    case "TemplateHeaderCellModel":
                        ext = new IgrTemplateHeaderCellInfo();
                        break;
                    case "TemplateSectionHeaderCellModel":
                        ext = new IgrTemplateSectionHeaderCellInfo();
                        break;
                    case "TextCellModel":
                        ext = new IgrTextCellInfo();
                        break;
                    case "TextHeaderCellModel":
                        ext = new IgrTextHeaderCellInfo();
                        break;
                }
                ext._implementation = this.i.cellInfo;
                this.i.cellInfo.externalObject = ext;
            }
            return this.i.cellInfo.externalObject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellValueChangingEventArgs.prototype, "editID", {
        /**
     * Gets the edit ID for this value change.
    */
        get: function () {
            return this.i.c;
        },
        set: function (v) {
            this.i.c = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellValueChangingEventArgs.prototype, "column", {
        /**
         * Gets the column the cell belongs to.
        */
        get: function () {
            if (this.i.b == null) {
                return null;
            }
            if (!this.i.b.externalObject) {
                var e = IgrColumn._createFromInternal(this.i.b);
                if (e) {
                    e._implementation = this.i.b;
                }
                this.i.b.externalObject = e;
            }
            return this.i.b.externalObject;
        },
        set: function (v) {
            v == null ? this.i.b = null : this.i.b = v.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellValueChangingEventArgs.prototype, "oldValue", {
        /**
         * Gets the old cell value.
        */
        get: function () {
            return this.i.e;
        },
        set: function (v) {
            this.i.e = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellValueChangingEventArgs.prototype, "newValue", {
        /**
         * Gets the new cell value.
        */
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridCellValueChangingEventArgs;
}());
export { IgrGridCellValueChangingEventArgs };
//# sourceMappingURL=igr-grid-cell-value-changing-event-args.js.map
